export const iconFontAwesomeMathematicsGreaterThanEqual = (
	<i className="fa-solid fa-greater-than-equal"></i>
);
